import { useSelector } from 'react-redux';
import { INTERACTION_ORIGIN } from '@constants/tracking';
import { FAVORITES_ITEMS_PARAMETERS } from '@common/MyLists/constants';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import FavoritesProducts from '../components/FavoritesProducts';
import FavoritesProductsSimple from '../components/FavoritesProductsSimple';
import { filterProductsWithSameVariant } from '../helpers/filters';

interface FavoritesListProps {
    isSimpleList: boolean;
    maxProducts: number;
    isRightSticky: boolean;
    pageSize: number;
    className: string;
}

function FavoritesList({
    isSimpleList,
    maxProducts = 6,
    isRightSticky = false,
    pageSize,
    className,
}: FavoritesListProps) {
    const products = useSelector(({ favorites }: any) => filterProductsWithSameVariant(favorites.products));
    const FavoritesComponent = isSimpleList ? FavoritesProductsSimple : FavoritesProducts;

    return (
        <FavoritesComponent
            className={className}
            interactionOrigin={INTERACTION_ORIGIN.favorites}
            isRightSticky={isRightSticky}
            itemsParameters={FAVORITES_ITEMS_PARAMETERS}
            maxProducts={Number(maxProducts)}
            pageSize={pageSize}
            products={products}
        />
    );
}

export const FavoritesStandalone = ReactOnRailsRootComponent(FavoritesList, { withReduxStore: true });
export default FavoritesList;
